import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner } from '../../components/Spinner';
import { Button } from '../../ui/button';
export const SubmitButton = ({ children, loading = false, icon, ...props }) => {
    return (_jsxs(Button, { ...props, type: "submit", children: [loading ? _jsx(Spinner, {}) : icon ? icon : _jsx(_Fragment, {}), children] }));
};
